import { Component, DestroyRef, inject, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import * as fromApp from '@store';
import { DocusignTemplate } from '@shared/models/docusign-template.model';
import { SpinnerService } from '@shared/spinner/spinner.service';
import { EnrollmentGroupService } from '@core/api/enrollment-group.service';

interface DialogData {
  dialogAction: string;
  template: DocusignTemplate;
}

@Component({
    selector: 'fc-add-docusign',
    templateUrl: './add-docusign-dialog.component.html',
    styleUrls: ['./add-docusign-dialog.component.scss'],
    standalone: false
})
export class AddDocusignDialogComponent {
  destroyRef = inject(DestroyRef);

  templateForm: UntypedFormGroup;
  dialogAction: string = 'Create';
  docusignTemplate: DocusignTemplate = null;

  constructor(
    readonly dialogRef: MatDialogRef<AddDocusignDialogComponent>,
    readonly formBuilder: UntypedFormBuilder,
    readonly store: Store<fromApp.AppState>,
    readonly spinnerService: SpinnerService,
    readonly enrollmentGroupService: EnrollmentGroupService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.dialogAction = data.dialogAction;
    this.docusignTemplate = data.template;
    this.templateForm = this.formBuilder.group({
      description: [this.docusignTemplate?.description || null, Validators.required],
      templateId: [this.docusignTemplate?.templateId || null, Validators.required],
    });
  }

  submitForm() {
    let template: DocusignTemplate = {
      description: this.templateForm.get('description').value,
      templateId: this.templateForm.get('templateId').value,
      id: this.docusignTemplate?.id,
    };
    this.enrollmentGroupService.addUpdateDocusignTemplate(template).subscribe((newTemplate: DocusignTemplate) => {
      this.dialogRef.close(newTemplate);
    });
  }
}
